import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserConfigService {
  private localStorageKey = 'userConfigApplicationLinkPlatform';

  setConfig(config: any) {
    localStorage.setItem(this.localStorageKey, JSON.stringify(config));
  }

  // Function to get user configuration from local storage
  getConfig() {
    const configString = localStorage.getItem(this.localStorageKey);
    return JSON.parse(configString);
  }

  // Function to clear user configuration from local storage
  clearConfig() {
    localStorage.removeItem(this.localStorageKey);
  }
}
